var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SearchBox',{ref:"searchbox",attrs:{"label":"Portador:","placeholder":"Busca Portador por Nome ou Código","funcaoBuscar":"getPortadoresLista"},on:{"selected":_vm.handleSelected}})
}
var staticRenderFns = []

export { render, staticRenderFns }